export default __webpack_public_path__ + "static/media/white bottles.3a664824.jpeg";